import StaffForm from './staff-form';
import {SaveButton} from '@/components/refinedev/action_buttons';
// import ClassesInStaffManager from './classes-in-staff-manager';
import {Tabs, TabsContent, TabsList, TabsTrigger} from '@/shadcn_components/ui/tabs';
import Section from '@/components/surface/Section';
import {FormProvider} from 'react-hook-form';
import {ChangeAccountPasswordButton} from '../../_shared/change-password-button';
import {CreateAccountButton} from '@/pages/_shared/create-account-button';
import {ChangeRoleButton} from '@/pages/_shared/change-role-button';
import { useEditForm } from '@/hooks/refinedev/useEditForm';

const StaffEdit = () => {
  // const [tab, setTab] = useState('general');
  const useFormResults = useEditForm({
    transformBeforeSave: StaffForm.transformBeforeSave,
    formProps: {
      refineCoreProps: {
        meta: {
          with: {
            department: true,
            job: true,
            user: {
              select: ['id', 'username'],
              with: ['roles'],
            },
          },
        },
      },
    },
  });
  const {
    handleSubmit,
    refineCore: {onFinish, query},
  } = useFormResults;
  const dataRecord = query?.data?.data;  

  return (
    <div className="max-w-xl mx-auto flex flex-col gap-y-4 ">
      <Tabs
        defaultValue="general"
        // value={tab} onValueChange={v => setTab(v)}
      >
        <TabsList className="flex gap-x-4">
          <TabsTrigger className="w-64" value="general">
            Thông tin chung
          </TabsTrigger>
          <TabsTrigger className="w-64" value="account">
            Tài khoản
          </TabsTrigger>
        </TabsList>
        {/*  */}
        <TabsContent value="general" forceMount className="data-[state=inactive]:hidden">
          <FormProvider {...useFormResults}>
            <form onSubmit={handleSubmit(onFinish)} className='flex flex-col gap-y-4'>
              <StaffForm />
              <SaveButton className="self-end" size='lg'/>
            </form>
          </FormProvider>
        </TabsContent>
        {/*  */}
        {/* {dataRecord && ( */}
        <TabsContent
          value="account"
          className="max-w-xl flex flex-col gap-y-4 data-[state=inactive]:hidden"
          forceMount
          // hidden={tab != 'account'}
        >
          <Section title="Đăng nhập bằng mật khẩu">
            <AccountInfo record={dataRecord} />
          </Section>
          {/* <Section title="Đăng nhập bằng tài khoản zalo">
            <ZaloAccount />
          </Section> */}
        </TabsContent>
        {/* )} */}
      </Tabs>
    </div>
  );
};

const AccountInfo = ({record}: {record: any}) => {
  if (!record) return null;
  const {user, id} = record || {};
  
  if (user)
    return (
      <>
        <p>Tên đăng nhập: {user.username}</p>
        <ChangeAccountPasswordButton user={user} />
        <ChangeRoleButton user={user} />
      </>
    );
  return (
    <>
      <p>Người này chưa có tài khoản đăng nhập</p>
      <CreateAccountButton resource="staffs" id={id} usernamePrefix="staff_" />
    </>
  );
};

export default StaffEdit;
